import LoopVideo from "@/components/marketing/motion/LoopVideo";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { cn } from "@/lib/utils";

const FORMATS = [
  {
    name: "Apple Music Portrait",
    file: "motion-portrait",
    className: "aspect-[3/4] h-[270px] max-[680px]:h-[190px]",
  },
  {
    name: "Apple Music Square",
    file: "motion-square",
    className: "aspect-square w-full",
  },
  {
    name: "Spotify Canvas",
    file: "motion-canvas",
    className: "aspect-[9/16] h-[270px] max-[680px]:h-[190px]",
  },
];

export default function MotionHeroFormats() {
  const reduceMotion = useMediaQuery("(prefers-reduced-motion: reduce)");

  return (
    <div
      role="group"
      aria-label="The same motion artwork in three platform formats"
      className="relative z-[1] grid w-[min(680px,100%)] grid-cols-3 items-end gap-6 max-[980px]:mx-auto max-[980px]:w-[min(720px,100%)] max-[680px]:gap-[9px]"
    >
      {FORMATS.map((format) => (
        <figure
          key={format.file}
          className="m-0 flex h-[350px] min-w-0 flex-col items-start justify-end max-[680px]:h-[260px]"
        >
          <LoopVideo
            src={`/marketing/motion/${format.file}.mp4`}
            poster={`/marketing/motion/${format.file}.webp`}
            playing={!reduceMotion}
            aria-label={`${format.name} motion artwork`}
            className={cn(
              "block max-w-full self-center overflow-hidden rounded-[15px] border border-white/[0.27] bg-[#050505] object-cover",
              format.className,
            )}
          />
          <figcaption className="mt-[13px] w-full text-center font-open-sans text-[13px] font-[750] leading-[1.3] text-white/[0.72] max-[680px]:mt-[10px] max-[680px]:min-h-[34px] max-[680px]:text-[11px]">
            {format.name}
          </figcaption>
        </figure>
      ))}
    </div>
  );
}
